<template>
	<h2>{{article.title}}</h2>
</template>

<script>
export default {
  props: ['article']
}
</script>



/** WEBPACK FOOTER **
 ** LbTitle.vue?618c4925
 **/